import merge from "lodash.merge";
import { useFieldArray, useFormContext } from "react-hook-form";
import { v4 as uuidv4 } from "uuid";
import ProjectItem from "../projects/ProjectItem";

export const getProjectModal = () => ({
  name: "",
  address: "",
  asset_class: "",
  completion_date: null,
  description: "",
  website: "",
});

export const getCurrentProjectModal = () => ({
  name: "",
  address: "",
  asset_class: "",
  expected_completion_date: null,
  description: "",
  website: "",
});

const Projects = ({ partnerIndex, partnerId }) => {
  const form = useFormContext();

  const { fields, append, remove } = useFieldArray({
    control: form.control,
    name: `partners[${partnerIndex}].projects`,
  });

  const addProject = () => {
    append({
      key: uuidv4(),
      ...merge(getProjectModal(), { partner_id: partnerId }),
    });
  };

  return (
    <div className={"border-gray mt-4"}>
      {fields.map((item, index) => (
        <ProjectItem
          key={item.id || item.key}
          index={index}
          partnerIndex={partnerIndex}
          onDelete={() => remove(index)}
        />
      ))}
      <div
        className={"fw-bold text-primary mb-3 px-4 d-inline-block"}
        role={"button"}
        onClick={addProject}
      >
        + Add one more Project
      </div>
    </div>
  );
};

export default Projects;
